// extracted by mini-css-extract-plugin
export default {"ClickerYears":"ClickerYears_ClickerYears__3Ib5x","Active":"ClickerYears_Active__qBPLc","ClickerYearsEl":"ClickerYears_ClickerYearsEl__ydtxj"};